import { render } from "./OrderChoosePaymentComponent.vue?vue&type=template&id=f2fe8932&ts=true"
import script from "./OrderChoosePaymentComponent.vue?vue&type=script&lang=ts"
export * from "./OrderChoosePaymentComponent.vue?vue&type=script&lang=ts"

import "./OrderChoosePaymentComponent.vue?vue&type=style&index=0&id=f2fe8932&lang=scss"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__